import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router-dom';
import { useResultContext } from '../context/ResultContextProvider';
import Loading from './Loading';

const Results = () => {
  const { results, isLoading, getResults, searchTerm, setSearchTerm } =
    useResultContext();
  const location = useLocation();

  useEffect(() => {
    if (searchTerm) {
      if (location.pathname === '/videos') {
        getResults(`/search/q=${searchTerm} videos`);
      } else {
        getResults(`${location.pathname}/q=${searchTerm}&num=40`);
      }
    }
  }, [searchTerm, location.pathname]);

  if (isLoading) {
    return <Loading />;
  }
  console.log(results);

  switch (location.pathname) {
    case '/search':
      return (
        <div className='flex flex-wrap justify-between space-y-6 sm:px-56'>
          {results?.map(({ link, title, description }, index) => (
            <div key={index} className=' w-full'>
              <a href={link} target='_blank' rel='noopener noreferrer'>
                <p className='text-sm'>
                  {link.length > 30 ? link.substring(0, 30) : link}
                </p>
                <p className='text-lg hover:underline dark:text-blue-300 text-blue-700'>
                  {title}
                </p>
                <p className='text-sm text-gray-500 dark:text-gray-300'>
                  {description.length > 100
                    ? description.substring(0, 100)
                    : description}
                </p>
              </a>
            </div>
          ))}
        </div>
      );
    case '/images':
      return (
        <div className='flex flex-wrap justify-center items-center'>
          {results?.map(({ image, link: { href, title } }, index) => (
            <a
              className='sm:p-3 p-5'
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              key={index}
            >
              <img src={image?.src} alt={title} loading='lazy' />
              <p className='w-36 break-words text-sm mt-2'>{title}</p>
            </a>
          ))}
        </div>
      );
    case '/videos':
      return (
        <div className='flex flex-wrap'>
          {results.map((video, index) => (
            <div key={index} className='p-2'>
              {console.log(video?.additional_links?.[0].href)}
              <ReactPlayer
                url={video?.additional_links?.[0].href}
                controls
                width={355}
                height={250}
              />
            </div>
          ))}
        </div>
      );
    case '/news':
      return (
        <div className='flex flex-wrap justify-between space-y-6 sm:px-56 items-center'>
          {results?.map(({ links, title, source, id }) => (
            <div key={id} className=' w-full'>
              <a
                href={links?.[0]?.href}
                target='_blank'
                rel='noopener noreferrer'
                className='hover:underline'
              >
                <p className='text-lg  dark:text-blue-300 text-blue-700'>
                  {title}
                </p>
                <div className='flex gap-4'>
                  <a href={source?.href}>{source?.href}</a>
                </div>
              </a>
            </div>
          ))}
        </div>
      );

    default:
      return 'Error';
  }
};

export default Results;
